module.exports = __webpack_public_path__ + "static/media/Technologies2.f314ef9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/Technologies2.png
// module id = 147
// module chunks = 0